import { EditOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Space, Switch, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Table from "../../../core/common/dataTable/index";
import QuillWYSIWYG from "../../../core/common/textEditor/QuillWYSIWYG";
import Toasts from "../../../core/common/toast";
import { API_URLS } from "../../../core/data/redux/apis/urls";
import {
  createFaqAnswer,
  createFaqQuestion,
  createIntent,
  deleteFaqQuestion,
  deleteIntent,
  getAllFaqAnswers,
  getAllFaqQuestions,
  getAllIntents,
} from "../../../core/data/redux/intentSlice";
import { getLanguages } from "../../../core/data/redux/languageSlice";
import Api from "../../../core/data/redux/utils/apiCall";
import DeleteModal from "../../../core/modals/deleteModal";
import { formatDateTime } from "../../../utils/dateUtils";
import { all_routes } from "../../router/all_routes";
import PermissionGuard from "../../permissionGuard";
import { isSupportViewer } from "../../../utils/permissionUtils";

const routes = all_routes;

interface Intent {
  id: number;
  intentName: string;
  description: string;
  question: string;
  answer: string;
  isActive: boolean;
}

interface FaqQuestion {
  id: string;
  question: string;
  intentId?: string;
  language?: string;
  created_at?: string;
}

interface FaqAnswer {
  id: string;
  answer: string;
  intent_id?: string;
  intent?: any;
  language?: string;
  created_at?: string;
}

const mockIntents: Intent[] = [
  {
    id: 1,
    intentName: "Greeting",
    description: "Basic greeting responses",
    question: "Hello, how are you?",
    answer:
      "Hi! I'm doing well, thank you for asking. How can I help you today?",
    isActive: true,
  },
  {
    id: 2,
    intentName: "Farewell",
    description: "Goodbye responses",
    question: "Goodbye",
    answer: "Thank you for chatting! Have a great day!",
    isActive: true,
  },
];

const Intent = () => {
  const [inputText, setInputText] = useState("");
  const [searchQuery, setSearchQuery] = useState(""); // This is what gets sent to backend for FAQ Questions
  const [chatbotInputText, setChatbotInputText] = useState("");
  const [chatbotSearchQuery, setChatbotSearchQuery] = useState(""); // This is what gets sent to backend for Chatbot
  const [isModalVisibleExcel, setIsModalVisibleExcel] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [docFile, setDocFile] = useState<File | null>(null);
  const [formFile, setFormFile] = useState<File | null>(null);
  const [isModalVisibleDoc, setIsModalVisibleDoc] = useState(false);
  const [isModalVisibleForm, setIsModalVisibleForm] = useState(false);
  const dispatch = useDispatch();
  const intentState = useSelector((state: any) => state.intentState);
  const languageState = useSelector((state: any) => state.languageState);

  const [intents, setIntents] = useState<Intent[]>(mockIntents);
  console.log(intentState, "intentState");
  const createIntentData = intentState?.createIntentData || null;
  const getAllIntentsData = intentState?.getAllIntentsData || null;
  const createFaqQuestionData = intentState?.createFaqQuestionData || null;
  const createFaqAnswerData = intentState?.createFaqAnswerData || null;
  const deleteIntentData = intentState?.deleteIntentData || null;
  const deleteFaqQuestionData = intentState?.deleteFaqQuestionData || null;

  const languageData = languageState?.data || null;

  const [listType, setListType] = useState<string>("chatbot");
  const [faqType, setFaqType] = useState<string>("chatbot"); // Type for FAQ: chatbot, faq, doc, form
  const [faqAnswerFile, setFaqAnswerFile] = useState<File | null>(null);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showDeleteToast, setShowDeleteToast] = useState(false);
  const [showUpdateToast, setShowUpdateToast] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState<number | string | null>(null);
  const [form] = Form.useForm();
  const [editingId, setEditingId] = useState<number | string | null>(null);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchData = () => {
    const params: any = {
      page: pagination.current,
      limit: pagination.pageSize,
    };

    // Add search query if exists (use searchQuery state, not inputText)
    if (listType === "questions" && searchQuery.trim()) {
      params.search = searchQuery.trim();
    }

    // Add query parameter for chatbot (use query instead of search)
    if (listType === "chatbot" && chatbotSearchQuery.trim()) {
      params.query = chatbotSearchQuery.trim();
    }

    if (listType === "chatbot") {
      dispatch(getAllIntents(params));
    } else if (listType === "questions") {
      dispatch(getAllFaqQuestions(params));
      if (!languageData) {
        dispatch(getLanguages({}));
      }
    } else if (listType === "answers") {
      dispatch(getAllFaqAnswers(params));
      if (!languageData) {
        dispatch(getLanguages({}));
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    dispatch,
    listType,
    pagination.current,
    pagination.pageSize,
    searchQuery,
    chatbotSearchQuery,
  ]);

  useEffect(() => {
    if (
      intentState.action === "list" &&
      intentState.loading === "fulfilled" &&
      intentState.data
    ) {
      let apiIntents = null;

      if (
        intentState.data.data &&
        intentState.data.data.data &&
        Array.isArray(intentState.data.data.data)
      ) {
        apiIntents = intentState.data.data.data;
      } else if (
        intentState.data.data &&
        Array.isArray(intentState.data.data)
      ) {
        apiIntents = intentState.data.data;
      } else if (
        intentState.data.result &&
        Array.isArray(intentState.data.result)
      ) {
        apiIntents = intentState.data.result;
      } else if (Array.isArray(intentState.data)) {
        apiIntents = intentState.data;
      } else if (
        intentState.data.intents &&
        Array.isArray(intentState.data.intents)
      ) {
        apiIntents = intentState.data.intents;
      } else {
        const dataObj = intentState.data.data;
        for (const key in dataObj) {
          if (Array.isArray(dataObj[key])) {
            apiIntents = dataObj[key];
            break;
          }
        }
      }

      if (apiIntents && Array.isArray(apiIntents)) {
        const mappedIntents = apiIntents.map((item: any, index: number) => {
          return {
            id: item.id || item._id || index + 1,
            intentName:
              item.intent_name ||
              item.intentName ||
              item.name ||
              item.title ||
              `Intent ${index + 1}`,
            description: item.description || item.desc || "",
            question:
              item.question ||
              item.sample_question ||
              item.user_query ||
              item.query ||
              "",
            answer:
              item.answer ||
              item.response ||
              item.bot_response ||
              item.reply ||
              "",
            isActive:
              item.is_active !== undefined
                ? item.is_active
                : item.status !== undefined
                ? item.status
                : item.active !== undefined
                ? item.active
                : true,
          };
        });
        setIntents(mappedIntents);
      }
    }
  }, [intentState]);

  useEffect(() => {
    if (
      intentState.action === "create" &&
      intentState.loading === "fulfilled"
    ) {
      setSuccessMessage("Intent created successfully!");
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 4000);
      setIsModalVisible(false);
      form.resetFields();
      setEditingId(null);
      dispatch(
        getAllIntents({ page: pagination.current, limit: pagination.pageSize })
      );
    }

    if (createIntentData?.status === 201 || createIntentData?.status === 200) {
      setIsModalVisible(false);
      form.resetFields();
      setEditingId(null);
      dispatch(
        getAllIntents({ page: pagination.current, limit: pagination.pageSize })
      );
    }
  }, [createIntentData, intentState, dispatch, form]);

  useEffect(() => {
    if (
      createFaqQuestionData?.status === 201 ||
      createFaqQuestionData?.status === 200
    ) {
      setSuccessMessage("FAQ question created successfully!");
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 4000);
      setIsModalVisible(false);
      form.resetFields();
      setEditingId(null);
      dispatch(
        getAllFaqQuestions({
          page: pagination.current,
          limit: pagination.pageSize,
        })
      );
    }
  }, [createFaqQuestionData]);

  useEffect(() => {
    if (
      createFaqAnswerData?.status === 201 ||
      createFaqAnswerData?.status === 200
    ) {
      setSuccessMessage("FAQ answer created successfully!");
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 4000);
      setIsModalVisible(false);
      form.resetFields();
      setEditingId(null);
      dispatch(
        getAllFaqAnswers({
          page: pagination.current,
          limit: pagination.pageSize,
        })
      );
    }
  }, [createFaqAnswerData]);

  // Handle delete intent success
  useEffect(() => {
    if (
      intentState.action === "delete" &&
      intentState.loading === "fulfilled" &&
      deleteIntentData
    ) {
      setSuccessMessage("Intent deleted successfully!");
      setShowDeleteToast(true);
      setTimeout(() => setShowDeleteToast(false), 3000);
      // Refresh the intents list
      dispatch(
        getAllIntents({ page: pagination.current, limit: pagination.pageSize })
      );
    }
    if (intentState.action === "delete" && intentState.loading === "rejected") {
      setSuccessMessage("Failed to delete intent. Please try again.");
      setShowDeleteToast(true);
      setTimeout(() => setShowDeleteToast(false), 3000);
    }
  }, [deleteIntentData, intentState, dispatch]);

  // Handle delete FAQ question success
  useEffect(() => {
    if (
      intentState.action === "delete_question" &&
      intentState.loading === "fulfilled" &&
      deleteFaqQuestionData
    ) {
      setSuccessMessage("FAQ question deleted successfully!");
      setShowDeleteToast(true);
      setTimeout(() => setShowDeleteToast(false), 3000);
      // Refresh the FAQ questions list
      dispatch(
        getAllFaqQuestions({
          page: pagination.current,
          limit: pagination.pageSize,
        })
      );
    }
    if (
      intentState.action === "delete_question" &&
      intentState.loading === "rejected"
    ) {
      setSuccessMessage("Failed to delete FAQ question. Please try again.");
      setShowDeleteToast(true);
      setTimeout(() => setShowDeleteToast(false), 3000);
    }
  }, [deleteFaqQuestionData, intentState, dispatch]);

  // Helper function to extract pagination from API response
  const getPaginationFromResponse = () => {
    try {
      if (listType === "chatbot" && intentState?.data) {
        // Structure: intentState.data.data.data = array, intentState.data.data.total/page/limit
        const apiResponse = intentState.data?.data || {};
        return {
          total: apiResponse.total || 0,
          page: apiResponse.page || 1,
          limit: apiResponse.limit || 10,
        };
      } else if (listType === "questions" && intentState?.faqQuestionData) {
        // API response structure from user:
        // Response: { data: { status: 200, message: "...", data: { data: [...], total: 18, page: 1, limit: 10 } } }
        // Redux slice returns: response.data
        // So: response.data = { status: 200, message: "...", data: { data: [...], total: 18, page: 1, limit: 10 } }
        // Redux stores: intentState.faqQuestionData = { status: 200, message: "...", data: { data: [...], total: 18, page: 1, limit: 10 } }
        // So path to pagination: intentState.faqQuestionData.data (contains total, page, limit)

        // Try the correct path first: intentState.faqQuestionData.data
        let apiResponse = intentState.faqQuestionData?.data;

        // If that doesn't have total/page/limit, try alternative paths
        if (
          !apiResponse ||
          (apiResponse.total === undefined &&
            apiResponse.page === undefined &&
            apiResponse.limit === undefined)
        ) {
          // Try nested path
          apiResponse =
            intentState.faqQuestionData?.data?.data ||
            intentState.faqQuestionData?.data ||
            intentState.faqQuestionData ||
            {};
        }

        console.log("=== FAQ Questions Pagination Extraction ===");
        console.log("Full faqQuestionData:", intentState.faqQuestionData);
        console.log("faqQuestionData.data:", intentState.faqQuestionData?.data);
        console.log(
          "faqQuestionData.data.data:",
          intentState.faqQuestionData?.data?.data
        );
        console.log("Selected apiResponse:", apiResponse);
        console.log(
          "apiResponse.total:",
          apiResponse.total,
          "type:",
          typeof apiResponse.total
        );
        console.log(
          "apiResponse.page:",
          apiResponse.page,
          "type:",
          typeof apiResponse.page
        );
        console.log(
          "apiResponse.limit:",
          apiResponse.limit,
          "type:",
          typeof apiResponse.limit
        );
        console.log("==========================================");

        // Extract values - convert to numbers and handle 0 as valid value
        const total =
          apiResponse.total !== undefined && apiResponse.total !== null
            ? Number(apiResponse.total)
            : 0;
        const page =
          apiResponse.page !== undefined && apiResponse.page !== null
            ? Number(apiResponse.page)
            : 1;
        const limit =
          apiResponse.limit !== undefined && apiResponse.limit !== null
            ? Number(apiResponse.limit)
            : 10;

        console.log("Final extracted pagination:", {
          total,
          page,
          limit,
          totalPages: Math.ceil(total / limit),
        });

        return {
          total: total,
          page: page,
          limit: limit,
        };
      } else if (listType === "answers" && intentState?.faqAnswerData) {
        const apiResponse = intentState.faqAnswerData?.data?.data || {};
        return {
          total: apiResponse.total || 0,
          page: apiResponse.page || 1,
          limit: apiResponse.limit || 10,
        };
      }
    } catch (error) {
      console.error("Error extracting pagination:", error);
    }
    return {
      total: pagination.total,
      page: pagination.current,
      limit: pagination.pageSize,
    };
  };

  useEffect(() => {
    try {
      const paginationData = getPaginationFromResponse();
      if (
        paginationData.total !== undefined ||
        paginationData.page !== undefined ||
        paginationData.limit !== undefined
      ) {
        setPagination((prev) => ({
          current: paginationData.page ?? prev.current,
          pageSize: paginationData.limit ?? prev.pageSize,
          total: paginationData.total ?? prev.total,
        }));
      }
    } catch (error) {
      // Handle pagination error silently
    }
  }, [
    intentState?.data,
    intentState?.faqQuestionData,
    intentState?.faqAnswerData,
    listType,
  ]);

  const chatbotColumns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      render: (_: any, __: any, index: number) => (
        <div>{(pagination.current - 1) * pagination.pageSize + index + 1}</div>
      ),
    },
    {
      title: "Intent Name",
      dataIndex: "intentName",
      render: (intentName: string) => (
        <div style={{ maxWidth: "300px", wordWrap: "break-word" }}>
          {intentName || "-"}
        </div>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (description: string) => (
        <div style={{ maxWidth: "400px", wordWrap: "break-word" }}>
          {description || "-"}
        </div>
      ),
    },
    ...(!isSupportViewer()
      ? [
          {
            title: "Actions",
            dataIndex: "actions",
            render: (_: any, record: Intent) => (
              <Space>
                <Button icon={<EditOutlined />} onClick={() => handleEdit(record)} />
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#delete_modal"
                  onClick={() => setDeleteId(record.id)}
                >
                  <i
                    className="ti ti-trash"
                    style={{ color: "#ff4d4f", fontSize: "16px" }}
                  />
                </Link>
              </Space>
            ),
          },
        ]
      : []),
  ];

  const faqQuestionColumns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      render: (_: any, __: any, index: number) => (
        <div>{(pagination.current - 1) * pagination.pageSize + index + 1}</div>
      ),
    },
    {
      title: "Question",
      dataIndex: "question",
      render: (question: string) => (
        <div style={{ maxWidth: "300px", wordWrap: "break-word" }}>
          {question || "-"}
        </div>
      ),
    },

    {
      title: "Answer",
      dataIndex: "answer",
      render: (answer: string) => (
        <div style={{ maxWidth: "300px", wordWrap: "break-word" }}>
          {answer || "-"}
        </div>
      ),
    },
    {
      title: "Intent",
      dataIndex: "intent",
      render: (intent: any, record: any) => (
        <span
          style={{
            backgroundColor: "#f0f0f0",
            padding: "2px 8px",
            borderRadius: "4px",
            fontSize: "12px",
          }}
        >
          {intent?.name || record?.intent_name || record?.intent_id || "-"}
        </span>
      ),
    },
    {
      title: "Language",
      dataIndex: "language",
      render: (language: string) => (
        <span
          style={{
            backgroundColor: "#e6f7ff",
            padding: "2px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            color: "#1890ff",
          }}
        >
          {language || "en"}
        </span>
      ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      render: (date: string) => (
        <div style={{ fontSize: "12px" }}>{formatDateTime(date)}</div>
      ),
    },
    ...(!isSupportViewer()
      ? [
          {
            title: "Actions",
            dataIndex: "actions",
            render: (_: any, record: FaqQuestion) => (
              <Space>
                <Button icon={<EditOutlined />} onClick={() => handleEdit(record)} />
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#delete_modal"
                  onClick={() => setDeleteId(record.id)}
                >
                  <i
                    className="ti ti-trash"
                    style={{ color: "#ff4d4f", fontSize: "16px" }}
                  />
                </Link>
              </Space>
            ),
          },
        ]
      : []),
  ];

  const faqAnswerColumns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      render: (_: any, __: any, index: number) => (
        <div>{(pagination.current - 1) * pagination.pageSize + index + 1}</div>
      ),
    },
    {
      title: "Answer",
      dataIndex: "answer",
      render: (answer: string) => (
        <div style={{ maxWidth: "400px", wordWrap: "break-word" }}>
          {answer || "-"}
        </div>
      ),
    },
    {
      title: "Intent",
      dataIndex: "intent",
      render: (intent: any, record: any) => (
        <span
          style={{
            backgroundColor: "#f0f0f0",
            padding: "2px 8px",
            borderRadius: "4px",
            fontSize: "12px",
          }}
        >
          {intent?.name || record?.intent_name || record?.intent_id || "-"}
        </span>
      ),
    },
    {
      title: "Language",
      dataIndex: "language",
      render: (language: string) => (
        <span
          style={{
            backgroundColor: "#e6f7ff",
            padding: "2px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            color: "#1890ff",
          }}
        >
          {language || "en"}
        </span>
      ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      render: (date: string) => (
        <div style={{ fontSize: "12px" }}>{formatDateTime(date)}</div>
      ),
    },
    ...(!isSupportViewer()
      ? [
          {
            title: "Actions",
            dataIndex: "actions",
            render: (_: any, record: FaqAnswer) => (
              <Space>
                <Button icon={<EditOutlined />} onClick={() => handleEdit(record)} />
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-inert={true}
                  data-bs-target="#delete_modal"
                  onClick={() => setDeleteId(record.id)}
                >
                  <i
                    className="ti ti-trash"
                    style={{ color: "#ff4d4f", fontSize: "16px" }}
                  />
                </Link>
              </Space>
            ),
          },
        ]
      : []),
  ];

  const handleAdd = () => {
    setEditingId(null);
    form.resetFields();
    setFaqType("chatbot");
    setFaqAnswerFile(null);
    if (listType === "chatbot") {
      form.setFieldsValue({
        isActive: true,
      });
    } else if (listType === "questions") {
      form.setFieldsValue({
        language: "en",
        type: "chatbot",
      });
    } else if (listType === "answers") {
      form.setFieldsValue({
        language: "en",
      });
    }
    setIsModalVisible(true);
  };

  const handleEdit = (record: Intent | FaqQuestion | FaqAnswer) => {
    setEditingId(record.id);
    if (listType === "chatbot") {
      form.setFieldsValue({
        intentName: (record as Intent).intentName,
        description: (record as Intent).description,
        isActive: (record as Intent).isActive,
      });
    } else {
      form.setFieldsValue(record);
    }
    setIsModalVisible(true);
  };

  const handleModalOk = async () => {
    try {
      const values = await form.validateFields();

      if (listType === "chatbot") {
        if (editingId) {
          setIntents(
            intents.map((intent) =>
              intent.id === editingId ? { ...values, id: editingId } : intent
            )
          );
          setShowUpdateToast(true);
          setTimeout(() => setShowUpdateToast(false), 3000);
          setIsModalVisible(false);
          form.resetFields();
          setEditingId(null);
        } else {
          const payload = {
            name: values.intentName,
            description: values.description,
            active: values.isActive,
          };

          dispatch(createIntent(payload));
        }
      } else if (listType === "questions") {
        const selectedType = values.type || faqType;

        const payload = {
          id: editingId || "",
          question: values.question,
          answer: values.answer,
          intent_id: values.intent_id || 6,
          language: values.language || "en",
          type: selectedType,
        };
        dispatch(createFaqQuestion(payload));
      } else if (listType === "answers") {
        if (editingId) {
          setShowUpdateToast(true);
          setTimeout(() => setShowUpdateToast(false), 3000);
          setIsModalVisible(false);
          form.resetFields();
          setEditingId(null);
        } else {
          const payload = {
            answer: values.answer,
            intent_id: values.intent_id,
            language: values.language || "en",
          };
          dispatch(createFaqAnswer(payload));
        }
      }
    } catch (error) {
      // Form validation errors are handled by Antd automatically
    }
  };

  const handleDelete = (id: number | string, e?: React.MouseEvent) => {
    // Prevent event propagation if event is provided
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    // Store the id - modal will be triggered by Bootstrap data attributes
    setDeleteId(id);
  };

  const [loading, setLoading] = useState(false);
  const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        const result = reader.result as string;
        // Remove: data:application/...;base64,
        const base64String = result.split(",")[1];
        resolve(base64String);
      };

      reader.onerror = (error) => reject(error);
    });
  };

  const handleUploadExcel = async () => {
    try {
      if (!file) {
        throw new Error("File is required");
      }

      setLoading(true);

      const base64 = await fileToBase64(file);

      const payload = {
        filestring: base64,
        mime_type: file.type,
        filename: file.name,
      };

      const res = await Api.post(API_URLS.uploadFile, payload);
      setIsModalVisibleExcel(false);
      dispatch(
        getAllIntents({ page: pagination.current, limit: pagination.pageSize })
      );
      dispatch(
        getAllFaqQuestions({
          page: pagination.current,
          limit: pagination.pageSize,
        })
      );
      // dispatch(getAllFaqAnswers({ page: pagination.current, limit: pagination.pageSize }));

      setFile(null);
      form.resetFields();
      setLoading(false);
      toast.success(res.data.message);
    } catch (error) {
      console.error("Error UploadExcel", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUploadDoc = async () => {
    try {
      if (!docFile) {
        throw new Error("File is required");
      }

      setLoading(true);

      const base64 = await fileToBase64(docFile);

      const payload = {
        filestring: base64,
        mime_type: docFile.type,
        filename: docFile.name,
        type: "doc",
      };

      const res = await Api.post(API_URLS.uploadFile, payload);
      setIsModalVisibleDoc(false);
      setDocFile(null);
      setLoading(false);
      toast.success(res.data.message || "Document uploaded successfully");
    } catch (error: any) {
      console.error("Error UploadDoc", error);
      toast.error(
        error?.response?.data?.message || "Failed to upload document"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmDelete = (response: string) => {
    if (response === "YES" && deleteId) {
      try {
        if (listType === "chatbot") {
          // Dispatch delete intent action
          dispatch(deleteIntent({ id: Number(deleteId) }));
        } else if (listType === "questions") {
          // Dispatch delete FAQ question action
          dispatch(deleteFaqQuestion({ id: Number(deleteId) }));
        } else {
          // For answers, show toast (if delete endpoint exists later)
          setShowDeleteToast(true);
          setTimeout(() => setShowDeleteToast(false), 3000);
        }
      } catch (error) {
        console.error("Error deleting item", error);
      }
    }
    setDeleteId(null);
  };

  const getTableData = () => {
    if (listType === "chatbot") {
      return intents;
    } else if (listType === "questions") {
      if (intentState?.faqQuestionData) {
        let data = null;
        if (
          intentState?.faqQuestionData?.data?.data?.data &&
          Array.isArray(intentState.faqQuestionData.data.data.data)
        ) {
          data = intentState.faqQuestionData.data.data.data;
        } else if (
          intentState?.faqQuestionData?.data?.data &&
          Array.isArray(intentState.faqQuestionData.data.data)
        ) {
          data = intentState.faqQuestionData.data.data;
        } else if (
          intentState?.faqQuestionData?.result &&
          Array.isArray(intentState.faqQuestionData.result)
        ) {
          data = intentState.faqQuestionData.result;
        } else if (
          intentState?.faqQuestionData?.data &&
          Array.isArray(intentState.faqQuestionData.data)
        ) {
          data = intentState.faqQuestionData.data;
        } else {
          data = [];
        }

        return Array.isArray(data) ? data : [];
      }
    } else if (listType === "answers") {
      if (intentState?.faqAnswerData) {
        let data = null;
        if (
          intentState?.faqAnswerData?.data?.data?.data &&
          Array.isArray(intentState.faqAnswerData.data.data.data)
        ) {
          data = intentState.faqAnswerData.data.data.data;
        } else if (
          intentState?.faqAnswerData?.data?.data &&
          Array.isArray(intentState.faqAnswerData.data.data)
        ) {
          data = intentState.faqAnswerData.data.data;
        } else if (
          intentState?.faqAnswerData?.result &&
          Array.isArray(intentState.faqAnswerData.result)
        ) {
          data = intentState.faqAnswerData.result;
        } else if (
          intentState?.faqAnswerData?.data &&
          Array.isArray(intentState.faqAnswerData.data)
        ) {
          data = intentState.faqAnswerData.data;
        } else {
          data = [];
        }

        return Array.isArray(data) ? data : [];
      }
    }
    return [];
  };

  const tableData = getTableData();

  // Use tableData directly since search is now handled by backend
  const filteredTableData = tableData;

  const getCurrentColumns = () => {
    if (listType === "chatbot") {
      return chatbotColumns;
    } else if (listType === "questions") {
      return faqQuestionColumns;
    } else if (listType === "answers") {
      return faqAnswerColumns;
    }
    return [];
  };

  const getModalTitle = () => {
    if (listType === "chatbot") {
      return editingId ? "Edit Intent" : "Add New Intent";
    } else if (listType === "questions") {
      return editingId ? "Edit FAQ Question" : "Add FAQ Question";
    } else if (listType === "answers") {
      return editingId ? "Edit FAQ Answer" : "Add FAQ Answer";
    }
    return "";
  };

  const getAddButtonText = () => {
    if (listType === "chatbot") {
      return "Add New Intent";
    } else if (listType === "questions") {
      return "Add FAQ Question";
    } else if (listType === "answers") {
      return "Add FAQ Answer";
    }
    return "Add";
  };

  const handlePagination = (paginationConfig: any) => {
    setPagination({
      current: paginationConfig.current,
      pageSize: paginationConfig.pageSize || pagination.pageSize,
      total: paginationConfig.total || pagination.total,
    });
    // fetchData will be triggered by useEffect when pagination.current changes
  };

  return (
    <div>
      <Toasts
        show={intentState.loading === "rejected"}
        message={intentState.error || "Operation failed"}
        title={"Failed"}
        type={"danger"}
      />

      <Toasts
        show={showSuccessToast}
        message={successMessage}
        title={"Success"}
        type={"success"}
      />

      <Toasts
        show={showUpdateToast}
        message="Update functionality will be implemented with API integration"
        title={"Info"}
        type={"warning"}
      />

      <Toasts
        show={showDeleteToast}
        message={successMessage || "Item deleted successfully"}
        title={
          intentState.action === "delete" && intentState.loading === "rejected"
            ? "Error"
            : "Success"
        }
        type={
          intentState.action === "delete" && intentState.loading === "rejected"
            ? "danger"
            : "success"
        }
      />

      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3 mb-5">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Chatbot Management</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Chatbot</li>
                </ol>
              </nav>
            </div>
            <div className="head-icons ms-2 d-flex align-items-center gap-2">
              {(listType === "chatbot" ||
                listType === "questions" ||
                listType === "answers") && (
                <PermissionGuard route="chatbot/add">
                  <Button
                    type="primary"
                    onClick={handleAdd}
                    icon={<i className="ti ti-square-rounded-plus me-2" />}
                    style={{
                      backgroundColor: "#c0282c",
                      border: "1px solid #c0282c",
                      fontWeight: "500",
                    }}
                  >
                    {getAddButtonText()}
                  </Button>
                </PermissionGuard>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                  <Tabs
                    activeKey={listType}
                    onChange={(key) => setListType(key)}
                    items={[
                      {
                        key: "chatbot",
                        label: "Chatbot",
                      },
                      {
                        key: "questions",
                        label: "FAQ Questions",
                      },

                      // {
                      //   key: 'answers',
                      //   label: 'FAQ Answers',
                      // },
                    ]}
                  />
                  {listType === "questions" && (
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        marginLeft: "auto",
                        marginTop: "8px",
                      }}
                    >
                      <Button
                        type="default"
                        onClick={() => {
                          const link = document.createElement("a");
                          link.href = "/format.xlsx";
                          link.download = "format.xlsx";
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                        icon={<i className="ti ti-download me-2" />}
                      >
                        Download Format
                      </Button>
                      {!isSupportViewer() && (
                        <Button
                          type="primary"
                          onClick={() => setIsModalVisibleExcel(true)}
                          icon={<i className="ti ti-file-upload me-2" />}
                        >
                          Upload Faq Questions
                        </Button>
                      )}
                    </div>
                  )}
                </div>
                <div className="card-body">
                  {listType === "chatbot" && (
                    <>
                      {/* Search Input for Chatbot - Always visible */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          gap: "8px",
                          marginBottom: "16px",
                          padding: "0 16px",
                        }}
                      >
                        <Input
                          placeholder="Search by Intent Name"
                          value={chatbotInputText}
                          onChange={(e) => setChatbotInputText(e.target.value)}
                          onPressEnter={() => {
                            setChatbotSearchQuery(chatbotInputText);
                            setPagination({ ...pagination, current: 1 });
                          }}
                          prefix={
                            <i
                              className="ti ti-search"
                              style={{ color: "#8c8c8c" }}
                            />
                          }
                          allowClear
                          onClear={() => {
                            setChatbotInputText("");
                            setChatbotSearchQuery("");
                            setPagination({ ...pagination, current: 1 });
                          }}
                          style={{
                            width: "250px",
                            height: "32px",
                          }}
                        />
                        <Button
                          type="primary"
                          size="small"
                          onClick={() => {
                            setChatbotSearchQuery(chatbotInputText);
                            setPagination({ ...pagination, current: 1 });
                          }}
                          style={{
                            height: "32px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          Search
                        </Button>
                      </div>

                      {intentState.loading === "pending" &&
                      intentState.action === "list" ? (
                        <div className="text-center py-4">
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <p className="mt-2 mb-0">Loading intents...</p>
                        </div>
                      ) : intents?.length === 0 ? (
                        <div
                          style={{
                            textAlign: "center",
                            padding: "40px 20px",
                            color: "#666",
                          }}
                        >
                          <i
                            className="ti ti-inbox"
                            style={{
                              fontSize: "48px",
                              marginBottom: "16px",
                              display: "block",
                            }}
                          />
                          <h5>No intents found</h5>
                          <p>
                            Click the "{getAddButtonText()}" button to create
                            one.
                          </p>
                        </div>
                      ) : (
                        <>
                          <Table
                            columns={getCurrentColumns()}
                            dataSource={intents.map((intent: Intent) => ({
                              ...intent,
                              key: intent.id,
                            }))}
                            Selection={false}
                            paginationConfig={{
                              ...pagination,
                              showSizeChanger: true,
                              showTotal: () => "",
                            }}
                            handlePagination={handlePagination}
                            loading={
                              intentState.loading === "pending" &&
                              intentState.action === "list"
                            }
                          >
                            <div />
                          </Table>
                          <style>
                            {`
                              .row.p-2{
                              display:none;
                              }
                              .table.datatable .ant-pagination,
                              .datanew .ant-pagination,
                              .dataTable .ant-pagination {
                                display: none !important;
                              }
                              `}
                          </style>

                          {/* Custom Pagination for Chatbot */}
                          {(() => {
                            const paginationData = getPaginationFromResponse();
                            const totalItems =
                              paginationData.total ?? pagination.total ?? 0;
                            const currentPage =
                              paginationData.page ?? pagination.current ?? 1;
                            const pageSize =
                              paginationData.limit ?? pagination.pageSize ?? 10;
                            const totalPages =
                              totalItems > 0
                                ? Math.ceil(totalItems / pageSize)
                                : 0;

                            if (totalPages <= 1) {
                              return null;
                            }

                            return (
                              <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
                                <div>
                                  <small className="text-muted">
                                    Showing{" "}
                                    {totalItems > 0 && intents.length > 0
                                      ? `${
                                          (currentPage - 1) * pageSize + 1
                                        }-${Math.min(
                                          (currentPage - 1) * pageSize +
                                            intents.length,
                                          totalItems
                                        )}`
                                      : totalItems > 0
                                      ? `${
                                          (currentPage - 1) * pageSize + 1
                                        }-${Math.min(
                                          currentPage * pageSize,
                                          totalItems
                                        )}`
                                      : "0"}{" "}
                                    of {totalItems} items
                                  </small>
                                </div>
                                <div className="d-flex gap-2 align-items-center">
                                  <button
                                    className="btn btn-sm"
                                    onClick={() =>
                                      handlePagination({
                                        current: currentPage - 1,
                                        pageSize: pageSize,
                                        total: totalItems,
                                      })
                                    }
                                    disabled={
                                      currentPage <= 1 ||
                                      intentState.loading === "pending"
                                    }
                                    style={{
                                      backgroundColor:
                                        currentPage <= 1 ? "#f5f5f5" : "white",
                                      borderColor: "#dee2e6",
                                      color:
                                        currentPage <= 1
                                          ? "#6c757d"
                                          : "#212529",
                                      minWidth: "80px",
                                      cursor:
                                        currentPage <= 1
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                  >
                                    Previous
                                  </button>

                                  {(() => {
                                    const pages: (number | string)[] = [];

                                    if (totalPages <= 7) {
                                      for (let i = 1; i <= totalPages; i++) {
                                        pages.push(i);
                                      }
                                    } else {
                                      if (currentPage <= 4) {
                                        for (let i = 1; i <= 5; i++) {
                                          pages.push(i);
                                        }
                                        pages.push("...");
                                        pages.push(totalPages);
                                      } else if (
                                        currentPage >=
                                        totalPages - 3
                                      ) {
                                        pages.push(1);
                                        pages.push("...");
                                        for (
                                          let i = totalPages - 4;
                                          i <= totalPages;
                                          i++
                                        ) {
                                          pages.push(i);
                                        }
                                      } else {
                                        pages.push(1);
                                        pages.push("...");
                                        pages.push(currentPage - 1);
                                        pages.push(currentPage);
                                        pages.push(currentPage + 1);
                                        pages.push("...");
                                        pages.push(totalPages);
                                      }
                                    }

                                    return pages.map((page, index) => {
                                      if (page === "...") {
                                        return (
                                          <span
                                            key={`ellipsis-${index}`}
                                            className="px-2 text-muted"
                                          >
                                            ...
                                          </span>
                                        );
                                      }
                                      const pageNum = page as number;
                                      const isActive = pageNum === currentPage;
                                      return (
                                        <button
                                          key={pageNum}
                                          className="btn btn-sm"
                                          onClick={() =>
                                            handlePagination({
                                              current: pageNum,
                                              pageSize: pageSize,
                                              total: totalItems,
                                            })
                                          }
                                          disabled={
                                            intentState.loading === "pending"
                                          }
                                          style={{
                                            backgroundColor: isActive
                                              ? "#fd7e14"
                                              : "white",
                                            color: isActive
                                              ? "white"
                                              : "#212529",
                                            borderColor: "#dee2e6",
                                            minWidth: "40px",
                                            cursor:
                                              intentState.loading === "pending"
                                                ? "not-allowed"
                                                : "pointer",
                                            fontWeight: isActive
                                              ? "bold"
                                              : "normal",
                                          }}
                                        >
                                          {pageNum}
                                        </button>
                                      );
                                    });
                                  })()}

                                  <button
                                    className="btn btn-sm"
                                    onClick={() =>
                                      handlePagination({
                                        current: currentPage + 1,
                                        pageSize: pageSize,
                                        total: totalItems,
                                      })
                                    }
                                    disabled={
                                      currentPage >= totalPages ||
                                      intentState.loading === "pending"
                                    }
                                    style={{
                                      backgroundColor:
                                        currentPage >= totalPages
                                          ? "#f5f5f5"
                                          : "white",
                                      borderColor: "#dee2e6",
                                      color:
                                        currentPage >= totalPages
                                          ? "#6c757d"
                                          : "#212529",
                                      minWidth: "80px",
                                      cursor:
                                        currentPage >= totalPages
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            );
                          })()}
                        </>
                      )}
                    </>
                  )}

                  {(listType === "questions" || listType === "answers") && (
                    <>
                      {/* Search Input - Always visible, positioned above content */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          gap: "8px",
                          marginBottom: "16px",
                          padding: "0 16px",
                        }}
                      >
                        <Input
                          placeholder="Search by Question && Answer"
                          value={inputText}
                          onChange={(e) => setInputText(e.target.value)}
                          onPressEnter={() => {
                            setSearchQuery(inputText); // Set search query on Enter
                            setPagination({ ...pagination, current: 1 });
                          }}
                          prefix={
                            <i
                              className="ti ti-search"
                              style={{ color: "#8c8c8c" }}
                            />
                          }
                          allowClear
                          onClear={() => {
                            setInputText("");
                            setSearchQuery(""); // Clear search query
                            setPagination({ ...pagination, current: 1 });
                          }}
                          style={{
                            width: "250px",
                            height: "32px",
                          }}
                        />
                        <Button
                          type="primary"
                          size="small"
                          onClick={() => {
                            setSearchQuery(inputText); // Set search query on button click
                            setPagination({ ...pagination, current: 1 });
                          }}
                          style={{
                            height: "32px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          Search
                        </Button>
                      </div>

                      {intentState.loading === "pending" &&
                      (intentState.action === "list_questions" ||
                        intentState.action === "list_answers") ? (
                        <div className="text-center py-4">
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <p className="mt-2 mb-0">Loading {listType}...</p>
                        </div>
                      ) : filteredTableData?.length === 0 ? (
                        <div
                          style={{
                            textAlign: "center",
                            padding: "40px 20px",
                            color: "#666",
                          }}
                        >
                          <i
                            className="ti ti-inbox"
                            style={{
                              fontSize: "48px",
                              marginBottom: "16px",
                              display: "block",
                            }}
                          />
                          <h5>No {listType} found</h5>
                          <p>
                            Click the "{getAddButtonText()}" button to create
                            one.
                          </p>
                        </div>
                      ) : (
                        <>
                          <Table
                            columns={getCurrentColumns()}
                            dataSource={filteredTableData}
                            Selection={false}
                            paginationConfig={{
                              ...pagination,
                              showSizeChanger: true,
                              showTotal: () => "",
                            }}
                            handlePagination={handlePagination}
                            loading={
                              intentState.loading === "pending" &&
                              (intentState.action === "list_questions" ||
                                intentState.action === "list_answers")
                            }
                          >
                            {/* Pass empty div to hide default search input */}
                            <div />
                          </Table>
                          <style>
                            {`
                              .row.p-2{
                              display:none;
                              }
                              .table.datatable .ant-pagination,
                              .datanew .ant-pagination,
                              .dataTable .ant-pagination {
                                display: none !important;
                              }
                              `}
                          </style>

                          {/* Custom Pagination for Questions/Answers */}
                          {(() => {
                            const paginationData = getPaginationFromResponse();
                            const totalItems =
                              paginationData.total ?? pagination.total ?? 0;
                            const currentPage =
                              paginationData.page ?? pagination.current ?? 1;
                            const pageSize =
                              paginationData.limit ?? pagination.pageSize ?? 10;
                            const totalPages =
                              totalItems > 0
                                ? Math.ceil(totalItems / pageSize)
                                : 0;

                            console.log("=== Pagination Display Debug ===");
                            console.log(
                              "Pagination Data from API:",
                              paginationData
                            );
                            console.log(
                              "Current Pagination State:",
                              pagination
                            );
                            console.log("Calculated Values:", {
                              totalItems,
                              currentPage,
                              pageSize,
                              totalPages,
                            });
                            console.log("================================");

                            // Show pagination if we have more than 1 page
                            if (totalPages <= 1) {
                              console.log("Hiding pagination: totalPages <= 1");
                              return null;
                            }

                            console.log(
                              "Showing pagination with",
                              totalPages,
                              "pages"
                            );

                            return (
                              <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
                                <div>
                                  <small className="text-muted">
                                    Showing{" "}
                                    {totalItems > 0 &&
                                    filteredTableData.length > 0
                                      ? `${
                                          (currentPage - 1) * pageSize + 1
                                        }-${Math.min(
                                          (currentPage - 1) * pageSize +
                                            filteredTableData.length,
                                          totalItems
                                        )}`
                                      : totalItems > 0
                                      ? `${
                                          (currentPage - 1) * pageSize + 1
                                        }-${Math.min(
                                          currentPage * pageSize,
                                          totalItems
                                        )}`
                                      : "0"}{" "}
                                    of {totalItems}{" "}
                                    {listType === "questions"
                                      ? "questions"
                                      : listType === "answers"
                                      ? "answers"
                                      : "items"}
                                  </small>
                                </div>
                                <div className="d-flex gap-2 align-items-center">
                                  {/* Previous Button */}
                                  <button
                                    className="btn btn-sm"
                                    onClick={() =>
                                      handlePagination({
                                        current: currentPage - 1,
                                        pageSize: pageSize,
                                        total: totalItems,
                                      })
                                    }
                                    disabled={
                                      currentPage <= 1 ||
                                      intentState.loading === "pending"
                                    }
                                    style={{
                                      backgroundColor:
                                        currentPage <= 1 ? "#f5f5f5" : "white",
                                      borderColor: "#dee2e6",
                                      color:
                                        currentPage <= 1
                                          ? "#6c757d"
                                          : "#212529",
                                      minWidth: "80px",
                                      cursor:
                                        currentPage <= 1
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                  >
                                    Previous
                                  </button>

                                  {/* Page Numbers */}
                                  {(() => {
                                    const pages: (number | string)[] = [];

                                    if (totalPages <= 7) {
                                      for (let i = 1; i <= totalPages; i++) {
                                        pages.push(i);
                                      }
                                    } else {
                                      if (currentPage <= 4) {
                                        for (let i = 1; i <= 5; i++) {
                                          pages.push(i);
                                        }
                                        pages.push("...");
                                        pages.push(totalPages);
                                      } else if (
                                        currentPage >=
                                        totalPages - 3
                                      ) {
                                        pages.push(1);
                                        pages.push("...");
                                        for (
                                          let i = totalPages - 4;
                                          i <= totalPages;
                                          i++
                                        ) {
                                          pages.push(i);
                                        }
                                      } else {
                                        pages.push(1);
                                        pages.push("...");
                                        pages.push(currentPage - 1);
                                        pages.push(currentPage);
                                        pages.push(currentPage + 1);
                                        pages.push("...");
                                        pages.push(totalPages);
                                      }
                                    }

                                    return pages.map((page, index) => {
                                      if (page === "...") {
                                        return (
                                          <span
                                            key={`ellipsis-${index}`}
                                            className="px-2 text-muted"
                                          >
                                            ...
                                          </span>
                                        );
                                      }
                                      const pageNum = page as number;
                                      const isActive = pageNum === currentPage;
                                      return (
                                        <button
                                          key={pageNum}
                                          className="btn btn-sm"
                                          onClick={() =>
                                            handlePagination({
                                              current: pageNum,
                                              pageSize: pageSize,
                                              total: totalItems,
                                            })
                                          }
                                          disabled={
                                            intentState.loading === "pending"
                                          }
                                          style={{
                                            backgroundColor: isActive
                                              ? "#fd7e14"
                                              : "white",
                                            color: isActive
                                              ? "white"
                                              : "#212529",
                                            borderColor: "#dee2e6",
                                            minWidth: "40px",
                                            cursor:
                                              intentState.loading === "pending"
                                                ? "not-allowed"
                                                : "pointer",
                                            fontWeight: isActive
                                              ? "bold"
                                              : "normal",
                                          }}
                                        >
                                          {pageNum}
                                        </button>
                                      );
                                    });
                                  })()}

                                  {/* Next Button */}
                                  <button
                                    className="btn btn-sm"
                                    onClick={() =>
                                      handlePagination({
                                        current: currentPage + 1,
                                        pageSize: pageSize,
                                        total: totalItems,
                                      })
                                    }
                                    disabled={
                                      currentPage >= totalPages ||
                                      intentState.loading === "pending"
                                    }
                                    style={{
                                      backgroundColor:
                                        currentPage >= totalPages
                                          ? "#f5f5f5"
                                          : "white",
                                      borderColor: "#dee2e6",
                                      color:
                                        currentPage >= totalPages
                                          ? "#6c757d"
                                          : "#212529",
                                      minWidth: "80px",
                                      cursor:
                                        currentPage >= totalPages
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            );
                          })()}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          <Modal
            title={
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <i className="ti ti-file-upload" />
                Upload Excel File
              </div>
            }
            open={isModalVisibleExcel}
            onOk={handleUploadExcel}
            onCancel={() => {
              setIsModalVisibleExcel(false);
              setFile(null);
              form.resetFields();
            }}
            width={500}
            okText={"Upload"}
            cancelText="Cancel"
            confirmLoading={loading}
          >
            <div style={{ padding: "20px 0" }}>
              <div
                style={{
                  border: "2px dashed #d9d9d9",
                  borderRadius: "8px",
                  padding: "40px 20px",
                  textAlign: "center",
                  backgroundColor: "#fafafa",
                  transition: "all 0.3s",
                  cursor: "pointer",
                  position: "relative",
                }}
                onDragOver={(e) => {
                  e.preventDefault();
                  e.currentTarget.style.borderColor = "#1890ff";
                  e.currentTarget.style.backgroundColor = "#e6f7ff";
                }}
                onDragLeave={(e) => {
                  e.currentTarget.style.borderColor = "#d9d9d9";
                  e.currentTarget.style.backgroundColor = "#fafafa";
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  e.currentTarget.style.borderColor = "#d9d9d9";
                  e.currentTarget.style.backgroundColor = "#fafafa";
                  const files = e.dataTransfer.files;
                  if (
                    files.length > 0 &&
                    files[0].name.match(/\.(xlsx|xls)$/i)
                  ) {
                    setFile(files[0]);
                  }
                }}
                onClick={() => {
                  const input = document.createElement("input");
                  input.type = "file";
                  input.accept = ".xlsx,.xls";
                  input.onchange = (e: any) => {
                    if (e.target.files && e.target.files[0]) {
                      setFile(e.target.files[0]);
                    }
                  };
                  input.click();
                }}
              >
                {file ? (
                  <div>
                    <i
                      className="ti ti-file-check"
                      style={{
                        fontSize: "48px",
                        color: "#52c41a",
                        marginBottom: "16px",
                      }}
                    />
                    <p
                      style={{
                        margin: "8px 0",
                        fontSize: "16px",
                        fontWeight: 500,
                        color: "#262626",
                      }}
                    >
                      {file.name}
                    </p>
                    <p
                      style={{
                        margin: "4px 0",
                        fontSize: "14px",
                        color: "#8c8c8c",
                      }}
                    >
                      {(file.size / 1024).toFixed(2)} KB
                    </p>
                    <Button
                      type="link"
                      onClick={(e) => {
                        e.stopPropagation();
                        setFile(null);
                      }}
                      style={{ marginTop: "8px" }}
                    >
                      Remove File
                    </Button>
                  </div>
                ) : (
                  <div>
                    <i
                      className="ti ti-cloud-upload"
                      style={{
                        fontSize: "48px",
                        color: "#1890ff",
                        marginBottom: "16px",
                      }}
                    />
                    <p
                      style={{
                        margin: "8px 0",
                        fontSize: "16px",
                        fontWeight: 500,
                        color: "#262626",
                      }}
                    >
                      Click or drag file to upload
                    </p>
                    <p
                      style={{
                        margin: "4px 0",
                        fontSize: "14px",
                        color: "#8c8c8c",
                      }}
                    >
                      Supports: .xlsx, .xls
                    </p>
                  </div>
                )}
              </div>
            </div>
          </Modal>

          {/* Doc Upload Modal */}
          <Modal
            title={
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <i className="ti ti-file-upload" />
                Upload Document
              </div>
            }
            open={isModalVisibleDoc}
            onOk={handleUploadDoc}
            onCancel={() => {
              setIsModalVisibleDoc(false);
              setDocFile(null);
            }}
            width={500}
            okText={"Upload"}
            cancelText="Cancel"
            confirmLoading={loading}
          >
            <div style={{ padding: "20px 0" }}>
              <div
                style={{
                  border: "2px dashed #d9d9d9",
                  borderRadius: "8px",
                  padding: "40px 20px",
                  textAlign: "center",
                  backgroundColor: "#fafafa",
                  transition: "all 0.3s",
                  cursor: "pointer",
                  position: "relative",
                }}
                onDragOver={(e) => {
                  e.preventDefault();
                  e.currentTarget.style.borderColor = "#1890ff";
                  e.currentTarget.style.backgroundColor = "#e6f7ff";
                }}
                onDragLeave={(e) => {
                  e.currentTarget.style.borderColor = "#d9d9d9";
                  e.currentTarget.style.backgroundColor = "#fafafa";
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  e.currentTarget.style.borderColor = "#d9d9d9";
                  e.currentTarget.style.backgroundColor = "#fafafa";
                  const files = e.dataTransfer.files;
                  if (files.length > 0) {
                    setDocFile(files[0]);
                  }
                }}
                onClick={() => {
                  const input = document.createElement("input");
                  input.type = "file";
                  input.accept = ".pdf,.doc,.docx,.txt";
                  input.onchange = (e: any) => {
                    if (e.target.files && e.target.files[0]) {
                      setDocFile(e.target.files[0]);
                    }
                  };
                  input.click();
                }}
              >
                {docFile ? (
                  <div>
                    <i
                      className="ti ti-file-check"
                      style={{
                        fontSize: "48px",
                        color: "#52c41a",
                        marginBottom: "16px",
                      }}
                    />
                    <p
                      style={{
                        margin: "8px 0",
                        fontSize: "16px",
                        fontWeight: 500,
                        color: "#262626",
                      }}
                    >
                      {docFile.name}
                    </p>
                    <p
                      style={{
                        margin: "4px 0",
                        fontSize: "14px",
                        color: "#8c8c8c",
                      }}
                    >
                      {(docFile.size / 1024).toFixed(2)} KB
                    </p>
                    <Button
                      type="link"
                      onClick={(e) => {
                        e.stopPropagation();
                        setDocFile(null);
                      }}
                      style={{ marginTop: "8px" }}
                    >
                      Remove File
                    </Button>
                  </div>
                ) : (
                  <div>
                    <i
                      className="ti ti-cloud-upload"
                      style={{
                        fontSize: "48px",
                        color: "#1890ff",
                        marginBottom: "16px",
                      }}
                    />
                    <p
                      style={{
                        margin: "8px 0",
                        fontSize: "16px",
                        fontWeight: 500,
                        color: "#262626",
                      }}
                    >
                      Click or drag file to upload
                    </p>
                    <p
                      style={{
                        margin: "4px 0",
                        fontSize: "14px",
                        color: "#8c8c8c",
                      }}
                    >
                      Supports: .pdf, .doc, .docx, .txt
                    </p>
                  </div>
                )}
              </div>
            </div>
          </Modal>

          <Modal
            title={
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <i className={`ti ti-${editingId ? "edit" : "plus"}`} />
                {getModalTitle()}
              </div>
            }
            open={isModalVisible}
            onOk={handleModalOk}
            onCancel={() => {
              setIsModalVisible(false);
              form.resetFields();
              setEditingId(null);
              setFaqType("chatbot");
              setFaqAnswerFile(null);
            }}
            confirmLoading={
              intentState.loading === "pending" &&
              (intentState.action === "create" ||
                intentState.action === "create_question" ||
                intentState.action === "create_answer")
            }
            width={500}
            okText={editingId ? "Update" : "Create"}
            cancelText="Cancel"
          >
            <Form form={form} layout="vertical">
              {listType === "chatbot" ? (
                <React.Fragment>
                  <Form.Item
                    name="intentName"
                    label="Intent Name"
                    rules={[
                      { required: true, message: "Please input intent name!" },
                      {
                        min: 2,
                        message: "Intent name must be at least 2 characters!",
                      },
                    ]}
                  >
                    <Input placeholder="Enter intent name" />
                  </Form.Item>

                  <Form.Item
                    name="description"
                    label="Description"
                    rules={[
                      {
                        max: 500,
                        message: "Description cannot exceed 500 characters!",
                      },
                    ]}
                  >
                    <Input.TextArea
                      placeholder="Enter intent description (optional)"
                      rows={3}
                      showCount
                      maxLength={500}
                    />
                  </Form.Item>

                  <Form.Item
                    name="isActive"
                    label="Status"
                    valuePropName="checked"
                  >
                    <Switch
                      checkedChildren="Active"
                      unCheckedChildren="Inactive"
                    />
                  </Form.Item>
                </React.Fragment>
              ) : listType === "questions" ? (
                <React.Fragment>
                  <Form.Item
                    name="type"
                    label="Type"
                    rules={[
                      { required: true, message: "Please select a type!" },
                    ]}
                    initialValue="chatbot"
                  >
                    <Select
                      placeholder="Select type"
                      onChange={(value) => {
                        setFaqType(value);
                        form.setFieldsValue({ answer: "" });
                        setFaqAnswerFile(null);
                      }}
                      style={{ width: "100%" }}
                    >
                      <Select.Option value="chatbot">Chatbot</Select.Option>
                      <Select.Option value="faq">FAQ</Select.Option>
                      <Select.Option value="doc">Doc</Select.Option>
                      <Select.Option value="form">Form</Select.Option>
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="question"
                    label="FAQ Question"
                    rules={[
                      { required: true, message: "Please input FAQ question!" },
                      {
                        min: 5,
                        message: "Question must be at least 5 characters!",
                      },
                    ]}
                  >
                    <Input.TextArea
                      placeholder="Enter FAQ question"
                      rows={3}
                      showCount
                      maxLength={1000}
                    />
                  </Form.Item>

                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) =>
                      prevValues.type !== currentValues.type
                    }
                  >
                    {({ getFieldValue }) => {
                      const currentType = getFieldValue("type") || faqType;
                      if (currentType === "chatbot") {
                        return (
                          <Form.Item
                            name="answer"
                            label="FAQ Answer"
                            rules={[
                              {
                                required: true,
                                message: "Please input FAQ answer!",
                              },
                              {
                                min: 10,
                                message:
                                  "Answer must be at least 10 characters!",
                              },
                            ]}
                          >
                            <Input.TextArea
                              placeholder="Enter FAQ answer"
                              rows={4}
                              showCount
                              maxLength={2000}
                            />
                          </Form.Item>
                        );
                      } else if (currentType === "faq") {
                        return (
                          <Form.Item
                            name="answer"
                            label="FAQ Answer"
                            rules={[
                              {
                                required: true,
                                message: "Please input FAQ answer!",
                              },
                            ]}
                          >
                            <QuillWYSIWYG
                              value={form.getFieldValue("answer") || ""}
                              onChange={(value) => {
                                form.setFieldsValue({ answer: value });
                              }}
                              height="300px"
                            />
                          </Form.Item>
                        );
                      } else if (
                        currentType === "doc" ||
                        currentType === "form"
                      ) {
                        return (
                          <Form.Item
                            name="answer"
                            label="FAQ Answer"
                            rules={[
                              {
                                required: true,
                                message: "Please enter FAQ answer!",
                              },
                            ]}
                          >
                            <Input.TextArea
                              placeholder="You can upload link"
                              rows={4}
                            />
                          </Form.Item>
                        );
                      }
                      return null;
                    }}
                  </Form.Item>

                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) =>
                      prevValues.type !== currentValues.type
                    }
                  >
                    {({ getFieldValue }) => {
                      const currentType = getFieldValue("type") || faqType;
                      // Show Related Intent for chatbot, doc, and form types, not for faq
                      if (
                        currentType === "chatbot" ||
                        currentType === "doc" ||
                        currentType === "form"
                      ) {
                        return (
                          <Form.Item name="intent_id" label="Related Intent">
                            <Select
                              placeholder="Select related intent (optional)"
                              showSearch
                              optionFilterProp="children"
                              allowClear
                              style={{ width: "100%" }}
                            >
                              {intents && Array.isArray(intents)
                                ? intents.map((intent: Intent) => (
                                    <Select.Option
                                      key={intent.id}
                                      value={intent.id}
                                    >
                                      {intent.intentName}
                                    </Select.Option>
                                  ))
                                : null}
                            </Select>
                          </Form.Item>
                        );
                      }
                      return null;
                    }}
                  </Form.Item>
                  <Form.Item
                    name="language"
                    label="Language"
                    rules={[
                      { required: true, message: "Please select a language!" },
                    ]}
                    initialValue="en"
                  >
                    <Select
                      placeholder="Select language"
                      showSearch
                      optionFilterProp="children"
                      loading={languageState?.loading === "pending"}
                      style={{ width: "100%" }}
                    >
                      {(() => {
                        const languages =
                          languageData?.result ||
                          languageData?.data ||
                          languageData ||
                          [];
                        const languagesArray = Array.isArray(languages)
                          ? languages
                          : [];

                        if (languagesArray.length > 0) {
                          return languagesArray
                            .filter((lang: any) => lang.status)
                            .map((lang: any) => (
                              <Select.Option key={lang.id} value={lang.code}>
                                {lang.name} ({lang.code})
                              </Select.Option>
                            ));
                        } else {
                          return [
                            <Select.Option key="en" value="en">
                              English (en)
                            </Select.Option>,
                            <Select.Option key="hi" value="hi">
                              Hindi (hi)
                            </Select.Option>,
                            <Select.Option key="fr" value="fr">
                              French (fr)
                            </Select.Option>,
                            <Select.Option key="es" value="es">
                              Spanish (es)
                            </Select.Option>,
                            <Select.Option key="de" value="de">
                              German (de)
                            </Select.Option>,
                          ];
                        }
                      })()}
                    </Select>
                  </Form.Item>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Form.Item
                    name="answer"
                    label="FAQ Answer"
                    rules={[
                      { required: true, message: "Please input FAQ answer!" },
                      {
                        min: 10,
                        message: "Answer must be at least 10 characters!",
                      },
                    ]}
                  >
                    <Input.TextArea
                      placeholder="Enter FAQ answer"
                      rows={4}
                      showCount
                      maxLength={2000}
                    />
                  </Form.Item>
                  <Form.Item
                    name="intent_id"
                    label="Related Intent"
                    rules={[
                      {
                        required: true,
                        message: "Please select a related intent!",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select related intent"
                      showSearch
                      optionFilterProp="children"
                      loading={intentState.loading === "pending"}
                      style={{ width: "100%" }}
                    >
                      {intents && Array.isArray(intents)
                        ? intents.map((intent: Intent) => (
                            <Select.Option key={intent.id} value={intent.id}>
                              {intent.intentName}
                            </Select.Option>
                          ))
                        : null}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="language"
                    label="Language"
                    rules={[
                      { required: true, message: "Please select a language!" },
                    ]}
                    initialValue="en"
                  >
                    <Select
                      placeholder="Select language"
                      showSearch
                      optionFilterProp="children"
                      loading={languageState?.loading === "pending"}
                      style={{ width: "100%" }}
                    >
                      {(() => {
                        const languages =
                          languageData?.result ||
                          languageData?.data ||
                          languageData ||
                          [];
                        const languagesArray = Array.isArray(languages)
                          ? languages
                          : [];

                        if (languagesArray.length > 0) {
                          return languagesArray
                            .filter((lang: any) => lang.status)
                            .map((lang: any) => (
                              <Select.Option key={lang.id} value={lang.code}>
                                {lang.name} ({lang.code})
                              </Select.Option>
                            ));
                        } else {
                          return [
                            <Select.Option key="en" value="en">
                              English (en)
                            </Select.Option>,
                            <Select.Option key="hi" value="hi">
                              Hindi (hi)
                            </Select.Option>,
                            <Select.Option key="fr" value="fr">
                              French (fr)
                            </Select.Option>,
                            <Select.Option key="es" value="es">
                              Spanish (es)
                            </Select.Option>,
                            <Select.Option key="de" value="de">
                              German (de)
                            </Select.Option>,
                          ];
                        }
                      })()}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="active"
                    label="Status"
                    valuePropName="checked"
                  >
                    <Switch
                      checkedChildren="Active"
                      unCheckedChildren="Inactive"
                    />
                  </Form.Item>
                </React.Fragment>
              )}
            </Form>
          </Modal>

          <DeleteModal handleDelete={handleConfirmDelete} />
        </div>

        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">DMRC Admin Panel, All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Intent;
